import React from 'react';

export interface InfoFieldProps {
  title: React.ReactNode;
  value: React.ReactNode;
}

const InfoField = ({ title, value }: InfoFieldProps): JSX.Element => {
  return (
    <>
      <h4>{title}</h4>
      <p>{value || <span className="bp5-text-muted">NONE</span>}</p>
    </>
  );
};

export default InfoField;
